export default {
    remove: 'Fjern',
    save: 'Gem',
    cancel: 'Annullér',
    loading: 'Indlæser…',
    value: 'Værdi',
    'action-bar.collapse': 'Skjul',
    'action-bar.expand': 'Vis',
    'action-bar.actions': 'Handlinger',
    'callout.note': 'Bemærk',
    'callout.important': 'Vigtig',
    'callout.tip': 'Tip',
    'callout.caution': 'Advarsel',
    'callout.warning': 'Advarsel',
    'collapsible-section.open': 'Åbn { header } sektion',
    'collapsible-section.close': 'Luk { header } sektion',
    'date-picker.today': 'Idag',
    'date-picker.month.heading': 'Måned',
    'date-picker.quarter.heading': 'Kvartal',
    'date-picker.year.heading': 'År',
    'chip-set.clear-all': 'Ryd alle',
    'snackbar.dismiss': 'Luk',
    'file.drag-and-drop-tips':
        'Træk & slip filen her, eller klik for at gennemse.',
    'file-viewer.message.unsupported-filetype':
        'Kan ikke vise en forhåndsvisning af denne filtype.',
    'file-viewer.message.try-other-options':
        'Hent filen eller åbn den i en ny fane.',
    'file-viewer.download': 'Hent',
    'file-viewer.exit-fullscreen': 'Afslut fuldskærm',
    'file-viewer.open-in-fullscreen': 'Åbn i fuld skærm',
    'file-viewer.open-in-new-tab': 'Åbn i en ny fane',
    'file-viewer.more-actions': 'Mere…',
    'editor-menu.bold': 'Fed',
    'editor-menu.italic': 'Kursiv',
    'editor-menu.strikethrough': 'Gennemstreget',
    'editor-menu.h1': 'Overskrift 1',
    'editor-menu.h2': 'Overskrift 2',
    'editor-menu.h3': 'Overskrift 3',
    'editor-menu.bulleted-list': 'Punktliste',
    'editor-menu.numbered-list': 'Nummereret liste',
    'editor-menu.blockquote': 'Blokcitat',
    'editor-menu.link': 'Tilføj link',
    'editor-link-menu.text': 'Tekst',
    'editor-link-menu.link': 'Link',
    'editor-menu.code-block': 'Kodeblok',
    'editor-menu.code': 'Kode',
    'editor-image-view.loading': 'Indlæser billede: { filename }...',
    'editor-image-view.failed': 'Noget gik galt med billede: { filename }',
    'editor-image-view.success': 'Billede: { filename } er klar',
    'editor-image-view.resize-handle':
        'Træk til højre eller venstre for at ændre størrelsen på billedet',
    'progress-bar': 'Fremskridtsindikator',
    'ai-avatar.label': 'AI-avatar',
    'ai-avatar.thinking': 'tænker',
    'table.select-all': 'Vælg alle rækker',
    'table.select-row': 'Vælg denne række',
    'profile-picture.remove': 'Fjern valgt billede',
    'profile-picture.unsupported-preview.title':
        'Ikke-understøttet billedformat',
    'profile-picture.unsupported-preview.description':
        'Vi kan ikke vise det valgte billede i denne browser. Vælg venligst en anden billedfil.',
};
